import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  GET_ARTICULO_ID,
  GET_ARTICULOS,
  SEARCH_ARTICULOS,
  REMOVE_ARTICULO,
} from '../../graphql/actions/articulo';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Subject from '@material-ui/icons/Subject';
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import Order from '../Order/Order';
import Filter from '../Filter/Filter';
import Limit from '../Limit/Limit';
import Paginate from '../Paginate/Paginate';
import Total from '../Total/Total';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import ArticuloDel from './ArticuloDel';

import sectionDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDataStyle';

const useStyles = makeStyles(sectionDataStyle);

const ArticuloData = (props) => {
  const classes = useStyles();
  const [numArticulos, setNumArticulos] = useState(9);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [search, setSearch] = useState('');
  const [eliminarArticuloModal, setEliminarArticuloModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_ARTICULO_ID,
      data: { getArticuloId: id },
    });
    setEliminarArticuloModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarArticuloModal(false);
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removeArticulo) setEliminarArticuloModal(false);
    else console.log('Error eliminando articulo.');
  };

  const updateCacheDel = (cache, id) => {
    const { getArticulos } = cache.readQuery({
      query: GET_ARTICULOS,
      variables: {
        paginate: {
          numArticulos: numArticulos,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevoArticulos = getArticulos.articulos.filter(
      (articulo) => articulo.id !== id
    );

    if (getArticulos && nuevoArticulos) {
      cache.writeQuery({
        query: GET_ARTICULOS,
        variables: {
          paginate: {
            numArticulos: numArticulos,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getArticulos: {
            articulos: nuevoArticulos,
          },
        },
      });
    }
  };

  const {
    loading: loadingArticulos,
    error: errorArticulos,
    data: dataArticulos,
    fetchMore,
  } = useQuery(GET_ARTICULOS, {
    variables: {
      paginate: {
        numArticulos: numArticulos,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [executeSearch, { loading: loadingSearch, data: dataSearch }] =
    useLazyQuery(SEARCH_ARTICULOS, {
      errorPolicy: 'all',
    });

  const [
    eliminarArticulo,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_ARTICULO, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const onSearchHandler = (event) => {
    event.preventDefault();
    executeSearch({
      variables: {
        paginate: {
          numArticulos: numArticulos,
          cursor: '',
          query: search,
          sortBy: { field: field, order: order },
        },
      },
    });
  };

  const removeArticuloHandler = (id) => {
    eliminarArticulo({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  const numArticulosChangedHandler = (event) => {
    if (event.target.name === 'numComponentes')
      setNumArticulos(event.target.value);
  };

  const fieldChangedHandler = (event) => {
    if (event.target.name === 'field') setField(event.target.value);
  };

  const orderChangedHandler = (event) => {
    if (event.target.name === 'order') setOrder(event.target.value);
  };

  const searchChangedHandler = (event) => {
    if (event.target.name === 'search') setSearch(event.target.value);
  };

  const onPaginationHandler = (cursor) => {
    fetchMore({
      variables: {
        paginate: {
          numArticulos: numArticulos,
          cursor: cursor,
          sortBy: { field: field, order: order },
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        fetchMoreResult.getArticulos.articulos = [
          ...prev.getArticulos.articulos,
          ...fetchMoreResult.getArticulos.articulos,
        ];
        return fetchMoreResult;
      },
    });
  };

  // const toEditHandler = (e) => {
  //   e.preventDefault();
  // };

  let showNotification = null;
  let seccionTitulo = null;
  let seccionOrderFilter = null;
  let seccionCardArticulo = null;
  let seccionBotonAdd = null;
  let seccionLimitPagination = null;
  let seccionTotal = null;
  let removeModal = (
    <ArticuloDel
      show={eliminarArticuloModal}
      close={eliminarCloseModalHandler}
      removeArticulo={removeArticuloHandler}
    />
  );

  if (loadingArticulos) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;
  if (loadingSearch) {
    seccionOrderFilter = (
      <div id='orderandfilter' className={classes.marginBottom20}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <Order />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorArticulos) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>
              Error al buscar los artículos en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionOrderFilter = null;
    seccionCardArticulo = null;
    seccionBotonAdd = null;
    seccionLimitPagination = null;
    seccionTotal = null;

    showNotification = errorArticulos.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorArticulos ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataArticulos && dataArticulos.getArticulos) {
    const { getArticulos } = dataArticulos;
    //console.log(getArticulos);
    if (getArticulos.articulos.length === 0) {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron artículos, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = null;
      seccionCardArticulo = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'articulo'} />
        </div>
      ) : null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>Artículos</h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'articulo'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardArticulo = (
        <GridContainer>
          {getArticulos.articulos.map((articulo) => (
            <GridItem xs={12} sm={4} md={4} key={articulo.node._id}>
              <Card color='dark' key={articulo.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {articulo.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {articulo.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/articulo/' + articulo.node._id);
                        }}
                      >
                        <Subject />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-articulo/' + articulo.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(articulo.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/articulo/' + articulo.node._id);
                        }}
                      >
                        Leer Artículo
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'articulo'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numArticulos}
                numdComponentesChange={numArticulosChangedHandler}
                nombreComponente={'Artículos'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={getArticulos.pageInfo.startCursor}
                cursorFinal={getArticulos.pageInfo.endCursor}
                tienePaginaSiguiente={getArticulos.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={getArticulos.totalCount}
            nombreComponente={'Artículos'}
          />
        </div>
      );
    }
  }

  if (dataSearch && dataSearch.searchArticulos) {
    const { searchArticulos } = dataSearch;

    if (searchArticulos.articulos.length === 0) {
      seccionTitulo = null;

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}></GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'articulo'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardArticulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron artículos en la busqueda.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionBotonAdd = null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'articulo'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardArticulo = (
        <GridContainer>
          {searchArticulos.articulos.map((articulo) => (
            <GridItem xs={12} sm={4} md={4} key={articulo.node._id}>
              <Card color='dark' key={articulo.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {articulo.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {articulo.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/articulo/' + articulo.node._id);
                        }}
                      >
                        <Subject />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-articulo/' + articulo.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(articulo.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/articulo/' + articulo.node._id);
                        }}
                      >
                        Leer Artículo
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'articulo'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdArticulos={numArticulos}
                numdArticulosChange={numArticulosChangedHandler}
                nombreComponente={'Artículos'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={searchArticulos.pageInfo.startCursor}
                cursorFinal={searchArticulos.pageInfo.endCursor}
                tienePaginaSiguiente={searchArticulos.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={searchArticulos.totalCount}
            nombreComponente={'Artículos'}
          />
        </div>
      );
    }
  }

  if (dataRemove && dataRemove.removeArticulo) {
    const { removeArticulo } = dataRemove;
    if (removeArticulo.success && removeArticulo.code === '200') {
      showNotification = (
        <Notification
          key={removeArticulo.code}
          mostrar={removeArticulo.success ? true : false}
          msg={removeArticulo.message}
          stt={removeArticulo.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionOrderFilter}
              {seccionCardArticulo}
              {seccionBotonAdd}
              {seccionLimitPagination}
              {seccionTotal}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(ArticuloData);
